import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import { appActions } from '../../../actions';

import AdminPageLayout from '../layout';
import InstitutionForm from '../institution-edit/form';

import PortalApi from '../../../services/PortalApi';
import Utils from '../../../services/Utils';

class InstitutionIndexPage extends React.PureComponent {
  state = {
    institutions: [],
  }

  async componentDidMount() {
    await this.loadInstitutions();
    this.props.finishLoading();
  }

  loadInstitutions = async () => {
    const institutions = await PortalApi.admin.getInstitutions();
    this.setState({
      institutions,
    });
  }

  renderInstitutions = () => {
    const { institutions } = this.state;

    const columns = [
      {
        Header: '# ID',
        accessor: row => row.id.toString(),
        id: 'id',
        width: 100,
        Cell: ({ value: id }) => (
          <Link className="edit-link" to={`/admin/institutions/${id}`}>
            {id}
          </Link>
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 500,
      },
      {
        Header: 'Name (short)',
        accessor: 'name_short',
        width: 500,
      },
      {
        Header: 'Name (Chinese)',
        accessor: 'name_chi',
        width: 500,
      },
      {
        Header: 'Sort order',
        accessor: 'sort_order',
        width: 100,
      },
      {
        Header: 'Created at',
        accessor: 'created_at',
        width: 300,
      },
      {
        Header: 'Updated at',
        accessor: 'updated_at',
        width: 300,
      },
    ];

    return (
      <div className="institutions-list">
        <ReactTable
          data={institutions}
          columns={columns}
          defaultPageSize={10}
          pageSizeOptions={[10, 25, 50, 100]}
          filterable
          defaultFilterMethod={Utils.reactTableFilterInsensitive}
        />
      </div>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <AdminPageLayout>
          <div className="main-content">
            <h1>Institution</h1>
            { this.renderInstitutions() }
            <hr />
            <div className="create-institution">
              <h1>Create New Institution</h1>
              <InstitutionForm mode="create" />
            </div>
          </div>
        </AdminPageLayout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  finishLoading: () => dispatch(appActions.finishLoading()),
});

InstitutionIndexPage.propTypes = {
  finishLoading: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

const StyledInstitutionIndexPage = styled(InstitutionIndexPage)`
`;

export default connect(
  null,
  mapDispatchToProps,
)(StyledInstitutionIndexPage);
